var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExcelGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1163 2H6.5C5.83696 2 5.20107 2.26339 4.73223 2.73223C4.26339 3.20107 4 3.83696 4 4.5V19.5C4 20.163 4.26339 20.7989 4.73223 21.2678C5.20107 21.7366 5.83696 22 6.5 22H16.5C17.163 22 17.7989 21.7366 18.2678 21.2678C18.7366 20.7989 19 20.163 19 19.5V7.88375C18.9999 7.55226 18.8682 7.23437 18.6337 7L14 2.36625C13.7656 2.13181 13.4477 2.00007 13.1163 2V2ZM13.375 6.375V3.875L17.125 7.625H14.625C14.2935 7.625 13.9755 7.4933 13.7411 7.25888C13.5067 7.02446 13.375 6.70652 13.375 6.375ZM5.25 13.25H17.75V14.5H9V17H17.75V18.25H9V20.75H7.75V18.25H5.25V17H7.75V14.5H5.25V13.25Z",
    fill: "#42A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcelGoogle);
export default ForwardRef;